<template>
  <!-- 表2 -->
  <div class="form-container">
    <div class="form-title margin-b20">表2-生产能力保障审查</div>
    <div
      v-for="(item, index) in evaluationProduceAbilityList"
      :key="item.nodeId"
      class="table-two-item"
      :style="{ 'border-bottom': !item.isShow ? '1px solid #dcdcdc' : 'none' }"
    >
      <div class="table-outer-title">
        <div>
          <div>评审项目：{{ item.ability }} 分值：{{ item.score }}分</div>
        </div>
        <div class="table-outer-btn">
          <eui-btn
            type="text"
            @click="showTwo(item)"
            style="font-size: 12px; color: #0064C8"
          >
            {{ !item.isShow ? '展开' : '收起' }}
            <eui-icon
              :icon="!item.isShow ? 'eicon-arrow-down' : 'eicon-arrow-up'"
              color="#0064C8"
            ></eui-icon>
          </eui-btn>
        </div>
      </div>
      <div class="table-wrapper table-1" v-show="item.isShow">
        <div class="table-header-wrapper">
          <div class="table-header">
            <div class="table-header-item one">二级指标</div>
            <div class="table-header-item two">三级指标</div>
            <div class="table-header-item three">评审标准</div>
            <div class="table-header-item four">分值</div>
          </div>
        </div>
        <div class="table-body-wrapper">
          <div class="table-body">
            <div
              class="table-body-item"
              v-for="(item2, index2) in item.children"
              :key="item2.nodeId"
            >
              <div class="one" style="flex: 1">{{ item2.ability }}</div>
              <div class="two" style="display: block; flex: 6">
                <div class="table-body-wrapper-inner" style="display: block">
                  <div class="table-body-inner">
                    <div
                      class="table-body-item-inner"
                      v-for="(item3, index3) in item2.children"
                      :key="item3.nodeId"
                    >
                      <div class="one" style="flex: 2">
                        <Tooltip :content="item3.ability"></Tooltip>
                        <!-- {{ item3.ability }} -->
                      </div>
                      <div class="two" style="flex: 2">
                        <Tooltip :content="item3.standard"></Tooltip>
                        <!-- {{ item3.standard }} -->
                      </div>
                      <div class="three" style="flex: 2">
                        {{ item3.score }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-body-wrapper-inner" style="display: block">
                  <div class="table-body-inner">
                    <div
                      class="table-body-item-inner"
                      style="border-top: 1px solid #dcdcdc"
                    >
                      <div
                        class="one"
                        style="flex: 6; display: flex; justify-content: flex-end; align-items: center; font-weight: 500; margin-right: 20px;"
                      >
                        {{ item2.ability }} 合计{{ getTotal(item2.children) }}分
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from './tooltip.vue';
export default {
  props: {
    evaluationProduceAbilityList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  components: { Tooltip },
  computed: {},
  mounted() {},
  methods: {
    getTotal(arr) {
      return arr.reduce((pre, cur) => {
        return pre + Number(cur.score);
      }, 0);
    },
    showTwo(item) {
      item.isShow = !item.isShow;
    }
  }
};
</script>
<style lang="scss" scoped>
.table-two-item {
  margin-top: 10px;
  &:first-child {
    margin-top: 0;
  }
}
.table-outer-title {
  height: 40px;
  padding: 0 10px 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #333;
  font-size: 12px;
  font-weight: 500;
  background: #f5f5f5;
  border: 1px solid #dcdcdc;
  border-bottom: none;
  .table-outer-btn {
    color: #0064c8;
    cursor: pointer;
  }
}
.table-1 {
  .table-header {
    height: 40px;
    display: flex;
    background: #f5f5f5;
    border: 1px solid #dcdcdc;
    .table-header-item {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #333;
      font-size: 12px;
      font-weight: 500;
      border-right: 1px solid #dcdcdc;
      &:last-child {
        border-right: none;
      }
    }
    .one {
      flex: 1;
      overflow: hidden;
    }
    .two {
      flex: 2;
      overflow: hidden;
    }
    .three {
      flex: 2;
      overflow: hidden;
    }
    .four {
      flex: 2;
      overflow: hidden;
    }
  }
  .table-body-wrapper {
    border: 1px solid #dcdcdc;
    border-top: none;
    .table-body {
      .table-body-item {
        min-height: 50px;
        display: flex;
        color: #333;
        font-size: 12px;
        font-weight: 500;
        border-top: 1px solid #dcdcdc;
        &:first-child {
          border-top: none;
        }
        & > div {
          display: flex;
          justify-content: center;
          align-items: center;
          border-right: 1px solid #dcdcdc;
          &:last-child {
            border-right: none;
          }
        }
        .one {
          flex: 1;
          overflow: hidden;
        }
        .two {
          flex: 2;
          overflow: hidden;
        }
        .three {
          flex: 2;
          overflow: hidden;
        }
        .four {
          flex: 2;
          overflow: hidden;
        }
      }
    }
  }
}
.table-body-wrapper-inner {
  border-top: none;
  .table-body-inner {
    .table-body-item-inner {
      min-height: 50px;
      display: flex;
      color: #333;
      font-size: 12px;
      font-weight: 500;
      border-top: 1px solid #dcdcdc;
      &:first-child {
        border-top: none;
      }
      & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #dcdcdc;
        &:last-child {
          border-right: none;
        }
      }
      .one {
        flex: 2;
        overflow: hidden;
      }
      .two {
        flex: 1;
        overflow: hidden;
      }
      .three {
        flex: 2;
        overflow: hidden;
      }
      .four {
        flex: 2;
        overflow: hidden;
      }
    }
  }
}
</style>
